import { StateRepository } from '@angular-ru/ngxs/decorators';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { State, StateToken, Store } from '@ngxs/store';
import { ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs';
import {
    IProductCategoryContext,
    IProductContextAssessmentStatus,
    IProductContextCase,
    IProductContextCaseStatus,
    IProductContextMetadataOwner,
    IProductInterviewConfig,
    IProductSmartActionReference,
    IProductStage
} from 'src/app/models/case';
import { INotification } from 'src/app/models/notifications';
import { Product } from 'src/app/models/product';
import { SignalREvent } from 'src/app/models/signalr';
import { TaskOrchestratorService } from 'src/app/services/task-orchestrator/task-orchestrator.service';
import {
    IDisqualificationReason,
    IInterviewHandler
} from 'src/app/shared/interview-new/models/interview-handler.models';
import { InterviewHandlerService } from 'src/app/shared/interview-new/services/interview-handler.service';
import { FeatureService } from 'src/app/shared/preview-feature/preview-feature.service';
import { BaseProductServiceSingle } from '../-base-product.service-single';
import { AlertService } from '../../alert.service';
import { CaseService } from '../../case/case.service';
import { GlobalService } from '../../global/global.service';
import { interviewSSIDataProviderToken } from '../../interview-providers/interview-data-provider.tokens';
import { AssessmentType } from '../../interview/interview.model';
import { MemberService } from '../../member/member.service';
import { ProductContextService } from '../../product-context/product-context.service';
import { TaskServiceFactory, TaskServiceFactoryFn } from '../../task/task.service';
import { UserService } from '../../user/user.service';
import { SSIInterviewData } from './ssi-interview-data';
import { SSIStateModel } from './ssi.state.models';


export const SSI_TOKEN_KEY = 'ssiState';
export const SSI_TOKEN_TOKEN = new StateToken<SSIService>(SSI_TOKEN_KEY);


@StateRepository()
@State<SSIStateModel>({
    name: SSI_TOKEN_TOKEN,
    defaults: {

    }
})
@Injectable()
export class SSIService extends BaseProductServiceSingle<SSIStateModel> {

    get stateToken() {
        return SSI_TOKEN_TOKEN;
    }



    // get status$(): Observable<IProductContextCaseStatus> {
    //     return this.store.select<IProductContextCaseStatus>(SSIService.status);
    // }

    // get statusSync(): IProductContextCaseStatus {
    //     return this.store.selectSnapshot<IProductContextCaseStatus>(SSIService.status);
    // }

    // get caseOwner$(): Observable<IProductContextMetadataOwner> {
    //     return this.store.select<IProductContextMetadataOwner>(SSIService.owner);
    // }

    // get caseOwnerSync(): IProductContextMetadataOwner {
    //     return this.store.selectSnapshot<IProductContextMetadataOwner>(SSIService.owner);
    // }

    // get sourceProduct$(): Observable<Product> {
    //     return this.store.select<Product>(SSIService.sourceProduct);
    // }

    // get productCategoryContext$(): Observable<IProductCategoryContext> {
    //     return this.store.select<IProductCategoryContext>(SSIService.productCategoryContext);
    // }

    // get productCategoryContextSync(): IProductCategoryContext {
    //     return this.store.selectSnapshot<IProductCategoryContext>(SSIService.productCategoryContext);
    // }

    // get metadataSync(): any {
    //     return this.store.selectSnapshot<IProductContextCase>(SSIService.metadata);
    // }
    // get metadata$(): Observable<any> {
    //     return this.store.select<any>(SSIService.metadata);
    // }

    // get currentCaseSync(): IProductContextCase {
    //     return this.store.selectSnapshot<IProductContextCase>(SSIService.currentCase);
    // }
    // get currentCase$(): Observable<IProductContextCase> {
    //     return this.store.select<IProductContextCase>(SSIService.currentCase);
    // }


    // get iconSync(): string {
    //     return this.store.selectSnapshot<string>(SSIService.icon);
    // }
    // get icon$(): Observable<string> {
    //     return this.store.select<string>(SSIService.icon);
    // }

    // get noCaseMessageSync(): string {
    //     return this.store.selectSnapshot<string>(SSIService.noCaseMessage);
    // }
    // get noCaseMessage$(): Observable<string> {
    //     return this.store.select<string>(SSIService.noCaseMessage);
    // }

    // get categoryDisplayNameSync(): string {
    //     return this.store.selectSnapshot<string>(SSIService.categoryDisplayName);
    // }
    // get categoryDisplayName$(): Observable<string> {
    //     return this.store.select<string>(SSIService.categoryDisplayName);
    // }

    // get caseStageSync(): IProductStage {
    //     return this.store.selectSnapshot<IProductStage>(SSIService.caseStage);
    // }
    // get caseStage$(): Observable<IProductStage> {
    //     return this.store.select<IProductStage>(SSIService.caseStage);
    // }


    // get notifications$(): Observable<INotification[]> {
    //     return this.store.select<INotification[]>(SSIService.notifications);
    // }

    // get productInterviewsSync(): IProductInterviewConfig[] {
    //     return this.store.selectSnapshot<IProductInterviewConfig[]>(SSIService.productInterviews);
    // }

    // get productInterviews$(): Observable<IProductInterviewConfig[]> {
    //     return this.store.select<IProductInterviewConfig[]>(SSIService.productInterviews);
    // }

    // get caseAssessmentSync(): IProductContextAssessmentStatus {
    //     return this.store.selectSnapshot<IProductContextAssessmentStatus>(SSIService.caseAssessment);
    // }
    // get caseAssessment$(): Observable<IProductContextAssessmentStatus> {
    //     return this.store.select<IProductContextAssessmentStatus>(SSIService.caseAssessment);
    // }

    // get stagesSync(): IProductStage[] {
    //     return this.store.selectSnapshot<IProductStage[]>(SSIService.stages);
    // }
    // get stages$(): Observable<IProductStage[]> {
    //     return this.store.select<IProductStage[]>(SSIService.stages);
    // }

    // get smartActionsSync(): IProductSmartActionReference[] {
    //     return this.store.selectSnapshot<IProductSmartActionReference[]>(SSIService.smartActions);
    // }
    // get smartActions$(): Observable<IProductSmartActionReference[]> {
    //     return this.store.select<IProductSmartActionReference[]>(SSIService.smartActions);
    // }


    get interviewDataProviderToken() {
        return interviewSSIDataProviderToken;
    }


    constructor(
        globalService: GlobalService,
        memberService: MemberService,
        userService: UserService,
        caseService: CaseService,
        productContextService: ProductContextService,
        confirmationService: ConfirmationService,
        router: Router,
        route: ActivatedRoute,
        alertService: AlertService,
        store: Store,
        featureService: FeatureService,
        taskOrchestratorService: TaskOrchestratorService,
        @Inject(TaskServiceFactory) taskService: TaskServiceFactoryFn

    ) {
        super(
            'SSI',
            memberService,
            userService,
            caseService,
            productContextService,
            confirmationService,
            router,
            route,
            alertService,
            SSIInterviewData,
            store,
            featureService,
            new InterviewHandlerService(),
            taskOrchestratorService
        );

        this.taskService = taskService().setContext();
        this.taskService.activate();
    }

    signalRFilter(event: SignalREvent): boolean {
        return true;
    }

    protected isProductDisabled(): boolean {
        return false;
    }

    async canInterviewAdvanceStage(status: string, disqualificationReason: IDisqualificationReason, interviewHandler: IInterviewHandler) {
        return status?.toUpperCase() === 'DISQUALIFIED' && interviewHandler.settings.type.toUpperCase() === AssessmentType.Eligibility.toUpperCase();
    }
}
